import { Box, Theme, useTheme } from '@mui/material';

export interface SummaryTextListItem {
  label: string;
  desc: string | number | JSX.Element;
}

export interface SummaryTextListProps {
  items: SummaryTextListItem[];
  opts?: {
    [key: string]: any;
  };
}

const getDefaults = (theme: Theme) => ({
  color: theme.palette.primary.main,
  fontSize: '1.6rem',
  spacing: 1,
  flexWrap: 'nowrap',
});

export default function SummaryTextList(props: SummaryTextListProps) {
  const theme = useTheme();
  const { items, opts = getDefaults(theme) } = props;

  return (
    <>
      {items.map((item, index) => (
        <Box key={index} display="flex" flexWrap={opts.flexWrap} mb={opts.spacing}>
          <Box>
            <Box sx={{ color: opts.color }} fontSize={opts.fontSize}>
              {item.label}
            </Box>
          </Box>
          <Box>
            <Box display="flex" minWidth={1} ml={1}>
              {(typeof item.desc === 'string' || typeof item.desc === 'number') && (
                <Box
                  component="span"
                  fontWeight="bold"
                  fontSize="1.6rem"
                  sx={{
                    wordWrap: 'break-word',
                    display: 'block',
                    maxWidth: '100%',
                  }}
                >
                  {item.desc}
                </Box>
              )}
              {typeof item.desc !== 'string' && typeof item.desc !== 'number' && <>{item.desc}</>}
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
}
